module.exports = __webpack_public_path__ + "img/7stars.6273a13a.svg";